import { render, staticRenderFns } from "./Duplicate-issues.vue?vue&type=template&id=78f1142b"
import script from "./Duplicate-issues.vue?vue&type=script&lang=js"
export * from "./Duplicate-issues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports